import { dashboardService } from '../_services'

const initialState = {
    webhooks: [], snackbar: false, snackbarText: "snackbar", projects: [],
    autocompleteLoading: false, tableLoading: false }

export const dashboard = {
    namespaced: true,
    state: initialState,
    actions: {
        getAllWebhooks(context) {
            dashboardService.getAllWebhooks().then(webhooks => {
                context.commit('updateWebhooks', webhooks)
            })
        },
        newWebhook(context, webhook){
            dashboardService.newWebhook(webhook).then(data => {
                if (!data.error) {
                    context.commit('pushWebhookEntry', data)
                    context.commit('showSnackbar', "New Webhook Added")
                } else {
                    context.commit('showSnackbar', data.error)
                }
            })
        },
        getAllProjects(context) {
            context.commit('toggleAutocompleteLoading')
            dashboardService.getAllProjects().then(data => {
                context.commit('updateProjects', data)
                context.commit('toggleAutocompleteLoading')
            })
        },
        deleteWebhook(context, webhook) {
            confirm("Are you sure you want to delete this webhook?") &&
                dashboardService.deleteWebhook(webhook.ID).then(data => {
                    if (!data.error){
                        context.commit('showSnackbar', "Webhook deleted")
                        context.commit('deleteWebhookEntry', webhook)
                    } else {
                        context.commit('showSnackbar', data.error)
                    }
                })
            }
    },
    mutations: {
        updateWebhooks(state, webhooks){
            state.tableLoading = false
            state.webhooks = webhooks
        },
        pushWebhookEntry(state, webhook){
            state.webhooks.unshift(webhook)
        },
        deleteWebhookEntry(state, webhook){
            const index = state.webhooks.indexOf(webhook)
            state.webhooks.splice(index, 1)
        },
        closeSnackbar(state) {
            state.snackbar = false
        },
        showSnackbar(state, text) {
            state.snackbarText = text
            state.snackbar = true
        },
        snackbar(state, value){
            state.snackbar = value
        },
        toggleAutocompleteLoading(state){
            state.autocompleteLoading = !state.autocompleteLoading
        },
        updateProjects(state, projects){
            state.projects = projects
        }
    },
}
